import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ImporterUrlComponent } from '../../../components/shared/wrench-action-drawer/importer-url/importer-url.component';
import { ResponseModalComponent } from '../../../components/shared/response-modal/response-modal.component';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
// import { KmlLoaderService } from '../kml-loader.service';
import { ConfigurationManagerService } from '../configuration-manager.service';
import { KmlService } from '../kml-loader.service';
// import { KmlLoaderService } from '../kml-loader.service'; // <-- Import your loader

@Injectable({
  providedIn: 'root'
})
export class ImporterService {
  constructor(
    private modalService: NgbModal,
    private http: HttpClient,
    private kmlLoader: KmlService
  ) {}

  async openImporterDialog(): Promise<{ type: string; url: string } | null> {
    const modalRef = this.modalService.open(ImporterUrlComponent, {
      windowClass: 'bottom-left-modal',
      backdrop: 'static',
      keyboard: false,
      backdropClass: 'transparent-backdrop'
    });

    return new Promise((resolve) => {
      const component = modalRef.componentInstance as ImporterUrlComponent;
      component.fileImported.subscribe((data) => {
        modalRef.close();
        resolve(data);
      });
      modalRef.dismissed.subscribe(() => resolve(null));
    });
  }

  async importFile(): Promise<void> {
    try {
      const result = await this.openImporterDialog();
      if (!result) return;

      if (result.type === 'KML Url') {
        const url = ConfigurationManagerService.settings.tezzeractAPi + ConfigurationManagerService.settings.ImportUrl;
        const response = await firstValueFrom(this.http.post(
          url,
          { url: result.url },
          { responseType: 'text' }
        ));

        if (response) {
              const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(response as string, "text/xml");
          await this.kmlLoader.loadKML(xmlDoc);
        }
      }
    } catch (error) {
      const responseModalRef = this.modalService.open(ResponseModalComponent, {
        centered: true,
        backdrop: 'static',
        keyboard: false
      });
      const component = responseModalRef.componentInstance as ResponseModalComponent;
      component.message = 'Unrecognizable file';
    }
  }
}